import ItineraryPriceLoader, {
    type ItineraryPriceLoaderFactory,
    type PriceObject,
} from '../ItineraryPriceLoader';
import { TripType } from '@utils/trip';
import { FlightsApiApiFlightsMinPricesPost } from '@clients/FlightApi';

export default class BundlePriceLoader extends ItineraryPriceLoader {
    constructor(props: Omit<ItineraryPriceLoaderFactory, 'tripType'>) {
        super({
            ...props,
            tripType: TripType.RoundTrip,
        });
    }

    override async fetchSinglePrices(
        fromDate: Date,
        toDate: Date,
        origin: string,
        destination: string
    ): Promise<PriceObject[]> {
        const citiesWithIataCode = (
            await import('@static/city_mappings.js')
        ).default.filter(c => c.IATACode != null);
        const originCode =
            citiesWithIataCode.find(city => city.ID.toString() === origin)
                ?.IATACode || '';
        const destinationCode =
            citiesWithIataCode.find(city => city.ID.toString() === destination)
                ?.IATACode || '';
        const { data } = await FlightsApiApiFlightsMinPricesPost({
            minPriceRequest: {
                AdultCount: this.adultCount,
                ChildCount: this.childCount,
                InfantCount: this.infantCount,
                EndDate: toDate.toISOString(),
                Destination: destinationCode,
                StartDate: fromDate.toISOString(),
                Origin: originCode,
            },
        });
        return data
            .filter(d => d.TotalFare)
            .reduce(
                (previousValue, currentValue) => [
                    ...previousValue,
                    {
                        date: currentValue.Date?.substring(0, 10) || '',
                        value: currentValue.TotalFare || 0,
                    },
                ],
                [] as PriceObject[]
            );
    }

    override get labeledPrices() {
        const original = super.labeledPrices;
        const priceStatus = this.currentSelectionStep;
        return original.map(price => ({
            ...price,
            bundle: price.value === '-' ? undefined : priceStatus,
        }));
    }
}
